
export default [
    { key: 0, value: "Production" },
    { key: 1, value: "Loss" },
    { key: 2, value: "Consumption" },
]

